export const GLOBAL_SEARCH_INPUT_DOM_ID = 'rq-global-search'
